import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ContentLoader, Margin, Text } from 'shared/components'

import BeneFormConfirm from './components/beneficiaryFormConfirm'

import * as styles from './styles'

const SignupBeneConfirmComponent = ({ onSubmit, getPreRegBenePublicInfo }) => {
  const [initialValues, setInitialValues] = useState({})
  useEffect(() => {
    const fetchData = async () => {
      const beneficiary = await getPreRegBenePublicInfo()
      setInitialValues(beneficiary)
    }

    fetchData()
  }, [])

  return initialValues.beneficiaryName ? (
    <Margin resetWhen="phone" css={styles.signupContainer}>
      <section css={styles.signupSection}>
        <Margin as="section" bottom={2}>
          <Text as="h2" size={24} white italic bold>
            Confirm your registration
          </Text>
        </Margin>
        <Margin as="section" tb={2}>
          <BeneFormConfirm initialValues={initialValues} onSubmit={onSubmit} />
        </Margin>
      </section>
    </Margin>
  ) : (
    <div css={styles.loaderWrapper}>
      <ContentLoader loading={true} />
    </div>
  )
}

SignupBeneConfirmComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  getPreRegBenePublicInfo: PropTypes.func.isRequired,
}

export default SignupBeneConfirmComponent
